import { compareAsc } from "date-fns";

import Dated from "../../types/base/Dated";

const updatedAtDateComparator = (a: Dated<Date>, b: Dated<Date>) =>
  compareAsc(a.updatedAt, b.updatedAt);

export default updatedAtDateComparator;
